import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup } from '@gem/popups';

import { SpaceForm } from '../../components/SpaceForm/SpaceForm';
import { IEditSpacePopupParams, useEditSpacePopupPresenter } from './EditSpacePopup.presenter';

export const EditSpacePopup: FC<ICommonPopupsProps<IEditSpacePopupParams>> = observer((props) => {
  const { t } = useTranslation();
  const presenter = useEditSpacePopupPresenter(props);

  return (
    <Popup
      title={t('space_edit_space')}
      isOpened={!!presenter.space}
      handlePrevStep={presenter.hasBackButton ? presenter.onBack : null}
      onClose={presenter.onClose}
    >
      <SpaceForm
        initialValues={presenter.initialValues}
        avatarTitle={presenter.avatarTitle}
        avatarColor={presenter.avatarColor}
        isEditMode={true}
        onFormStateChange={presenter.onFormStateChange}
        onSubmit={presenter.onSubmit}
      ></SpaceForm>
    </Popup>
  );
});
